var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('RaftLogoImage',{staticClass:"raft-logo__image"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }